import { createFileRoute } from "@tanstack/react-router"
import NoosAvailabilityTab from "~/components/noos-supply-plan/NoosAvailabilityTab"
import {
  type AvailabilityReportSearch,
  isAvailabilityGroupBy,
} from "~/components/noos-supply-plan/useCategoryAvailability"
import { usePageTracking } from "~/hooks/usePageTracking"
import { FilterScopeProvider } from "~/providers/FilterScopeProvider"

const MONTH_KEY = /^\d{4}-\d{2}$/

const nonEmptyString = (value: unknown) => (typeof value === "string" && value ? value : undefined)

// Overview deep link: `field` + `value` filters on load, `field` alone clears that filter, `month`
// (yyyy-MM) is tinted and scrolled to. `category` / `allCategories` are the older links' form.
export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability",
)({
  validateSearch: (search: Record<string, unknown>): AvailabilityReportSearch => {
    const month =
      typeof search.month === "string" && MONTH_KEY.test(search.month) ? search.month : undefined
    const category = nonEmptyString(search.category)
    if (category) return { field: "category", value: category, month }
    if (search.allCategories === true || search.allCategories === "true") {
      return { field: "category", month }
    }
    if (!isAvailabilityGroupBy(search.field)) return { month }
    return { field: search.field, value: nonEmptyString(search.value), month }
  },
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan Detail - Availability")
  const { field, value, month } = Route.useSearch()
  const navigate = Route.useNavigate()
  // Own scope with a fixed key (the same one the app-wide scope uses here): the linked filter
  // is put back when the tab unmounts, and the app-wide scope has moved to the next route by then.
  return (
    <FilterScopeProvider scopeKey={Route.id}>
      <NoosAvailabilityTab
        field={field}
        value={value}
        month={month}
        onPeriodChange={() =>
          void navigate({ search: (prev) => ({ ...prev, month: undefined }), replace: true })
        }
      />
    </FilterScopeProvider>
  )
}
